module.exports = __webpack_public_path__ + "img/new_product.153cc46f.png";